
export default {
  isochronesDetails: {
    'polygons': 'Sokszögek',
    'center': 'Középpont',
    'reachCenters': 'Elérési központok',
    'toggleVisibility': 'Kapcsolja be a láthatóságot',
    'opacity': 'Átlátszatlanság'
  }
}
